import { render } from "./EventRegistration.vue?vue&type=template&id=760e8562&scoped=true"
import script from "./EventRegistration.vue?vue&type=script&lang=js"
export * from "./EventRegistration.vue?vue&type=script&lang=js"

import "./EventRegistration.vue?vue&type=style&index=0&id=760e8562&scoped=true&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps/frontendadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760e8562"]])

export default __exports__